import enviro from 'enviro';
import { lazy } from 'react';
import AlreadyAPartnerView from '../app-active-error/AlreadyAPartnerView';
import BlankScreenLoadingErrorView from '../app-active-error/BlankScreenLoadingErrorView';
import EmailVerificationStandardError from '../app-active-error/EmailVerificationStandardError';
import ExistingAccountLoginView from '../app-active-error/ExistingAccountLoginView';
import ManualLoginView from '../app-active-error/ManualLoginView';
import PartnerExistingAccountErrorView from '../app-active-error/PartnerExistingAccountErrorView';
import PendingEmailOAuthError from '../app-active-error/PendingEmailOAuthError';
import RateLimitedCreationError from '../app-active-error/RateLimitedCreationError';
import RateLimitedEmailVerification from '../app-active-error/RateLimitedEmailVerification';
import SessionExpiredErrorView from '../app-active-error/SessionExpiredErrorView';
import StandardCreationError from '../app-active-error/StandardCreationError';
import StandardError from '../app-active-error/StandardError';
import VerificationLinkExpiredView from '../app-active-error/VerificationLinkExpiredView';
import VerifyFirstCreationError from '../app-active-error/VerifyFirstCreationError';
import WordpressAuthorizationErrorView from '../app-active-error/WordpressAuthorizationErrorView';
import EmbeddedSignupContinueScreen from '../app/EmbeddedSignupContinueScreen';
import { getSentryExtra } from '../error/getSentryExtra';
import Logger from '../lib/Logger';
import RecaptchaCreationErrorView from '../recaptcha/RecaptchaCreationErrorView';
import { RecaptchaMissingInformationErrorView } from '../recaptcha/RecaptchaMissingInformationErrorView';
import NoPartnerPortalsErrorView from '../standalone-cms-partner/NoPartnerPortalsErrorView';
import PartnerNoRegisteredLeadsView from '../standalone-cms-partner/PartnerNoRegisteredLeadsView';
import UnauthedPartnerUserErrorView from '../standalone-cms-partner/UnauthedPartnerUserError';
import ExistingAccountsFetchError from '../step-existing-accounts/ExistingAccountsFetchError';
import CmsPartnerExistingUserView from '../step-existing-user/CmsPartnerExistingUserView';
import LandingPageView from '../step-landing-page/LandingPageView';
import CmsPartnerCompanyDomainAndNameView from './CmsPartnerCompanyDomainAndName';
import { CompanyNameView } from './CompanyNameView';
import CompanySizeView from './CompanySizeView';
import CrmExperienceLevelView from './CrmExperienceLevelView';
import { Step } from 'signup-constants/Step';
import MissingBlogIdeasGeneratorScopesView from '../app-active-error/MissingBlogIdeasGeneratorScopesErrror';
import UserSizeView from './UserSizeView';
const LOG = Logger.getLogger('stepViews');
const AfterFirstStepViewBundle = import('./afterFirstStepViews');
const AuthenticatedUserViewBundle = import('./authenticatedUserViews');
const loadViewFromBundle = (bundle, view) => {
  return /*#__PURE__*/lazy(() => bundle.then(module => {
    return {
      default: module[view]
    };
  }).catch(error => {
    LOG.error('bundle error:', {
      extra: getSentryExtra(error)
    });
    return {
      default: null
    };
  }));
};
export const BaseInputStepView = loadViewFromBundle(AfterFirstStepViewBundle, 'BaseInputView');
export const BaseButtonStepView = loadViewFromBundle(AfterFirstStepViewBundle, 'BaseButtonsView');

// Step -> StepView Mapping
export const StepViews = new Map();
StepViews.set(Step.UserSize, UserSizeView);
StepViews.set(Step.CompanyName, CompanyNameView);
StepViews.set(Step.CompanySize, CompanySizeView);
StepViews.set(Step.CrmExperienceLevel, CrmExperienceLevelView);
StepViews.set(Step.JobField, BaseButtonStepView);
StepViews.set(Step.EmailVerificationNotFound, VerificationLinkExpiredView);
StepViews.set(Step.InternalError, StandardError);
StepViews.set(Step.LoginFailed, ManualLoginView);
StepViews.set(Step.StandardCreationError, StandardCreationError);
StepViews.set(Step.VerifyFirstCreationError, VerifyFirstCreationError);
StepViews.set(Step.RateLimitedCreationError, RateLimitedCreationError);
StepViews.set(Step.OAuthExistingLoginFailed, ExistingAccountLoginView);
StepViews.set(Step.OAuthPendingEmailVerification, PendingEmailOAuthError);
StepViews.set(Step.RateLimitedEmailVerification, RateLimitedEmailVerification);
StepViews.set(Step.EmailVerificationFailed, EmailVerificationStandardError);
StepViews.set(Step.SessionExpired, SessionExpiredErrorView);
StepViews.set(Step.ExistingAccountsFetchFailed, ExistingAccountsFetchError);
StepViews.set(Step.RecaptchaCreationError, RecaptchaCreationErrorView);
StepViews.set(Step.RecaptchaMissingInformationError, RecaptchaMissingInformationErrorView);
StepViews.set(Step.BlankScreenLoadingError, BlankScreenLoadingErrorView);
StepViews.set(Step.PartnerExistingAccountError, PartnerExistingAccountErrorView);
StepViews.set(Step.AlreadyAPartner, AlreadyAPartnerView);
StepViews.set(Step.MissingBlogIdeasGeneratorScopesError, MissingBlogIdeasGeneratorScopesView);
StepViews.set(Step.WordpressAuthorizationError, WordpressAuthorizationErrorView);
StepViews.set(Step.CmsExistingUser, CmsPartnerExistingUserView);
StepViews.set(Step.CmsPartnerCompanyDomainAndName, CmsPartnerCompanyDomainAndNameView);
StepViews.set(Step.PartnerNoRegisteredLeads, PartnerNoRegisteredLeadsView);
StepViews.set(Step.UnauthedPartnerUserError, UnauthedPartnerUserErrorView);
StepViews.set(Step.NoPartnerPortalsError, NoPartnerPortalsErrorView);
StepViews.set(Step.EmbeddedSignupContinueScreen, EmbeddedSignupContinueScreen);
StepViews.set(Step.Industry, loadViewFromBundle(AfterFirstStepViewBundle, 'IndustryView'));
StepViews.set(Step.JobRole, loadViewFromBundle(AfterFirstStepViewBundle, 'JobRoleView'));
StepViews.set(Step.ManagementLevel, loadViewFromBundle(AfterFirstStepViewBundle, 'ManagementLevelView'));
StepViews.set(Step.Verification, loadViewFromBundle(AfterFirstStepViewBundle, 'VerificationView'));
StepViews.set(Step.ResendEmail, loadViewFromBundle(AfterFirstStepViewBundle, 'ResendEmailView'));
StepViews.set(Step.CodeVerification, loadViewFromBundle(AfterFirstStepViewBundle, 'CodeVerificationView'));
StepViews.set(Step.Password, /*#__PURE__*/lazy(() => import('../step-password/PasswordView')));
StepViews.set(Step.ProblemAwareness, /*#__PURE__*/lazy(() => import('./ProblemAwarenessView')));
StepViews.set(Step.ProductExperience, /*#__PURE__*/lazy(() => import('./ProductExperienceView')));
StepViews.set(Step.MobileAppPrompt, /*#__PURE__*/lazy(() => import('../step-mobile-app-prompt/MobileAppPromptView')));
StepViews.set(Step.ExistingUser, loadViewFromBundle(AuthenticatedUserViewBundle, 'ExistingUserView'));
StepViews.set(Step.ExistingAccounts, loadViewFromBundle(AuthenticatedUserViewBundle, 'ExistingAccountsView'));
StepViews.set(Step.HublessNoAccount, loadViewFromBundle(AuthenticatedUserViewBundle, 'HublessView'));
StepViews.set(Step.FirstName, /*#__PURE__*/lazy(() => import('./FirstNameView')));
StepViews.set(Step.LastName, /*#__PURE__*/lazy(() => import('./LastNameView')));
StepViews.set(Step.CompanyDomain, /*#__PURE__*/lazy(() => import('../step-company-domain/CompanyDomainView')));
StepViews.set(Step.IntegrationsAccountCreated, /*#__PURE__*/lazy(() => import('./IntegrationsAccountCreatedView')));
StepViews.set(Step.WordpressAuthorization, /*#__PURE__*/lazy(() => import('./WordpressAuthorizationView')));
StepViews.set(Step.WordpressConnectRedirect, /*#__PURE__*/lazy(() => import('./WordpressConnectRedirectView')));
StepViews.set(Step.HubInterest, /*#__PURE__*/lazy(() => import('./HubInterestView')));
StepViews.set(Step.AcademyEmbeddedExistingUser, /*#__PURE__*/lazy(() => import('../step-existing-user/AcademyEmbeddedExistingUserView')));
StepViews.set(Step.HubletSelection, /*#__PURE__*/lazy(() => import('../hublets/HubletSelectionView')));
StepViews.set(Step.Country, /*#__PURE__*/lazy(() => import('../countrySelect/CountrySelectView')));
StepViews.set(Step.PhoneNumber, /*#__PURE__*/lazy(() => import('../step-phone-number/PhoneNumberView')));
StepViews.set(Step.OptionalPhoneNumber, /*#__PURE__*/lazy(() => import('../step-phone-number/PhoneNumberOptionalView')));
StepViews.set(Step.Name, /*#__PURE__*/lazy(() => import('./NameView')));
StepViews.set(Step.LandingPage, LandingPageView);
StepViews.set(Step.InstallSalesExtension, /*#__PURE__*/lazy(() => import('../views-components/InstallSalesExtensionView')));
StepViews.set(Step.CmsSignupIntent, /*#__PURE__*/lazy(() => import('./CmsSignupIntentView')));
StepViews.set(Step.CmsBusinessMaturity, /*#__PURE__*/lazy(() => import('./CmsBusinessMaturityView')));
StepViews.set(Step.UseCase, /*#__PURE__*/lazy(() => import('./UseCaseView')));
StepViews.set(Step.UserSize, /*#__PURE__*/lazy(() => import('./UserSizeView')));
StepViews.set(Step.WhatsNext, /*#__PURE__*/lazy(() => import('./WhatsNextView')));
export const getStepView = stepKey => {
  const view = StepViews.get(stepKey);
  if (!view) {
    throw new Error(`No step view registered for step ${stepKey}. Check StepViews mapping.`);
  }
  return view;
};

// Local development information
if (enviro.isQa() && !enviro.deployed()) {
  const allSteps = Object.values(Step);
  const notIncludedInConfig = allSteps.filter(x => !StepViews.has(x));
  /* eslint-disable no-console */
  console.group('StepViews Debug Information');
  console.info('Step without a view component registered', notIncludedInConfig);
  console.groupEnd();
}